import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";

const PreguntasPuntualidad = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasPuntualidad();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Puntualidad (1/6)"
			opciones={[
				{ key: "llegaPuntualmente", label: "Llega puntualmente a sus turnos y rutas asignadas" },
				{ key: "cumpleHorarios", label: "Cumple con los horarios y rutas establecidos sin desviaciones injustificadas" },
				{ key: "reportaCualquierContratiempo", label: "Reporta cualquier contratiempo de forma oportuna" }
			]}
		/>
	);
};

export default PreguntasPuntualidad;
